<template>
  <main role="main" class="py-4">
    <b-container class="mb-3">
      <div v-if="isLoading" class="text-center py-5"><b-spinner /></div>

      <template v-if="customer">
        <div class="d-flex flex-row justify-content-between mb-4">
          <h4 class="m-0">{{ customer.name }}</h4>
        </div>

        <div class="d-flex flex-row">
          <div class="left-panel mr-4">
            <b-list-group>
              <b-list-group-item :to="'/customers/details/' + id" active-class="" exact-active-class="active">{{ $t("overview") }}</b-list-group-item>
              <b-list-group-item :to="`/customers/details/${id}/subscription`" active-class="" exact-active-class="active">{{ $t("subscriptionPlan") }}</b-list-group-item>
              <b-list-group-item :to="`/customers/details/${id}/meetings`" active-class="" exact-active-class="active">{{ $t("meeting") }}</b-list-group-item>
            </b-list-group>
          </div>
          <div class="flex-grow-1">
            <router-view></router-view>
          </div>
        </div>
      </template>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>
  .left-panel {
    width: 150px;
    flex-shrink: 0;
  }
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  import * as util from "@/service/util";
  import * as customerService from "@/service/customerService";


  @Component
  export default class CustomerDetails extends BaseComponent {

    id: number = null;

    isLoading = false;
    customer = null;

    mounted() {
      this.id = +this.$route.params.id || null;
      this.fetchCustomer();
    }


    async fetchCustomer() {
      try {
        this.isLoading = true;
        this.customer = await customerService.getDetails(this.id);

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isLoading = false;
      }
    }

  }
</script>
